import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { LocalStorageService } from 'ngx-webstorage';
import { FunctService,DtoService } from '@services/index';
import { catchError, } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ads-slider',
  templateUrl: './ads-slider.component.html',
  styleUrls: ['./ads-slider.component.scss'],
  
})
export class AdsSliderComponent {
  adsList: any=[];
  marqueeText: any={};
  loadingSubmiting: boolean=false;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    items: 1,
    autoplay: true,
    lazyLoad: true,
    //autoplayTimeout: 3000,
    autoplaySpeed: 2000,
    //animateOut: 'fadeOut',
    // animateIn: 'slideInRight',
    // animateOut: 'slideOutLeft',
    // animateIn: 'flipInX',
    navSpeed: 700,
    autoHeight: true,
    navText: ['', ''],
    responsive: {
      400: {
        items: 1
      },
      // 0: {
      //   items: 1
      // },
      // 400: {
      //   items: 2
      // },
      // 740: {
      //   items: 3
      // },
      // 940: {
      //   items: 4
      // }
    },
    // nav: true
  }

  constructor(private storage: LocalStorageService, 
    private spinner: NgxSpinnerService, 
    private toastr: ToastrService, 
    private http: HttpClient, 
    public dto: DtoService,   
    private funct: FunctService) {

  }
  ngOnInit() {
    this.getAdsList();    
  }
 trackById(index: number, item: any) {
  return item.id; // or any unique key
}
  handleError(error: HttpErrorResponse) {    
    this.loadingSubmiting=false;
    this.spinner.hide();
    if (error.status == 423) {
    }
    if (error.status == 400) {
      this.toastr.error("Bad request.", 'Invalid!', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
    }
    return throwError(error);
  }

  getAdsList(): void {
    this.loadingSubmiting= true;
    this.spinner.show();
    let localData = this.storage.retrieve('localhomeadsList');
  
    if(localData != null && localData != undefined){
       this.adsList = localData;
       this.loadingSubmiting=false;
       this.spinner.hide();
    }
    let headers = new HttpHeaders();
    let params = new HttpParams();
    params = params.set('gameProviderId', "0");
    this.http.get(this.funct.ipaddress + 'happy/GethappyAdsList', { params: params, headers: headers })
      .pipe(
        catchError(this.handleError.bind(this))
      )
      .subscribe(
        result => {         
          this.dto.Response = result;
          this.storage.store('localhomeadsList', this.dto.Response);
          this.adsList = this.dto.Response; 
          this.getMarqueeText();
          this.loadingSubmiting=false;
          this.spinner.hide();

        }
      );
  }

  getMarqueeText() {   
    let localMarqueeText = this.storage.retrieve('localmarqueeText');
    if(localMarqueeText != null && localMarqueeText != undefined) this.marqueeText = localMarqueeText;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    params = params.set('providerId', "0");
    this.http.get(this.funct.ipaddress + 'happy/gethappyMarqueeText', { params: params, headers: headers })
      .pipe(
        catchError(this.handleError.bind(this))
      )
      .subscribe(
        result => {
          this.dto.Response = {};
          this.dto.Response = result;
          this.storage.store('localmarqueeText', this.dto.Response);
          this.marqueeText = this.dto.Response;                 
        }
      );
  }
}
